module.exports = __webpack_public_path__ + "static/media/Free_Coffee.37b26621.svg";